import _ from 'lodash';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Modal from '../common/Modal/Modal';
import GenericButton from '../common/GenericButton';
import CommonDropdown from '../common/CommonDropdown';
import * as salesCatalystActions from '../../actions/salesCatalystActions';
import { PREFERENCE_SALES_CATALYST, PREFERENCE_SALES_CATALYST_SELECTED_SE_LIST,
  PREFERENCE_SALES_CATALYST_ENTITY, PREFERENCE_STUDY, PREFERENCE_SALES_CATALYST_REACH,
  PREFERENCE_SALES_CATALYST_SAMPLE, PREFERENCE_SALES_CATALYST_SCATTERPLOT_CATEGORY,
  PREFERENCE_SALES_CATALYST_STUDY_FAMILY, PREFERENCE_BRAND_CATALYST,
  PREFERENCE_BRAND_CATALYST_STUDY_FAMILY,
  PREFERENCE_SALES_CATALYST_SCATTERPLOT_BASE } from '../../constants';
import alertIcon from '../../images/alert-icon_238-51-50.png';
import { SC_PACKAGE_EDIT_LIST_WARNING, INVALID_DATA_POINTS } from '../../messages/messages';

const scSubEntitiesSlKey = `${PREFERENCE_SALES_CATALYST}.${PREFERENCE_SALES_CATALYST_SELECTED_SE_LIST}`;
const scEntityPersonaKey = `${PREFERENCE_SALES_CATALYST}.${PREFERENCE_SALES_CATALYST_ENTITY}`;
const scScatterplotDC = `${PREFERENCE_SALES_CATALYST}.${PREFERENCE_SALES_CATALYST_SCATTERPLOT_CATEGORY}`;
const scScatterplotBase = `${PREFERENCE_SALES_CATALYST}.${PREFERENCE_SALES_CATALYST_SCATTERPLOT_BASE}`;
const scDefaultStudy = `${PREFERENCE_SALES_CATALYST}.${PREFERENCE_STUDY}`;
const bcDefaultStudy = `${PREFERENCE_BRAND_CATALYST}.${PREFERENCE_STUDY}`;
const scReach = `${PREFERENCE_SALES_CATALYST}.${PREFERENCE_SALES_CATALYST_REACH}`;
const scSample = `${PREFERENCE_SALES_CATALYST}.${PREFERENCE_SALES_CATALYST_SAMPLE}`;
const scStudyFamily = `${PREFERENCE_SALES_CATALYST}.${PREFERENCE_SALES_CATALYST_STUDY_FAMILY}`;
const bcStudyFamily = `${PREFERENCE_BRAND_CATALYST}.${PREFERENCE_BRAND_CATALYST_STUDY_FAMILY}`;

const editWarningStyle = {
  width: '60%',
  height: '60px',
  left: '20%',
  top: '20%',
};

class PreferencesCommonDropdown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      options: [],
      responseData: undefined,
      selectedOption: undefined,
      seErrorMsgFlag: false,
      seInvalidDataPoints: [],
    };
  }

  componentDidMount() {
    this.mountMethod();
  }

  /* eslint-disable camelcase */
  UNSAFE_componentWillReceiveProps(nextProps) {
    const { field, modifiedPreferences } = this.props;
    const { responseData, selectedOption } = this.state;
    if (modifiedPreferences !== nextProps.modifiedPreferences) {
      if (field.dbKey === scSubEntitiesSlKey) {
        const oldEntityInfo = this.getKeyData(scEntityPersonaKey);
        const newEntityInfo = this.getKeyData(scEntityPersonaKey, false,
          nextProps.modifiedPreferences);
        const newTemplateInfo = this.getKeyData(field.dbKey, false, nextProps.modifiedPreferences);
        if (!_.isEqual(oldEntityInfo, newEntityInfo)) {
          this.createList(responseData, field.action.labelKey, field.action.valueKey,
            nextProps.modifiedPreferences);
        }
        if (!_.isEqual(selectedOption, newTemplateInfo)) {
          if (!_.isEmpty(newTemplateInfo)) {
            this.createSelectOptions();
          }
          this.setSelectedOption(newTemplateInfo);
        }
      } else if (field.dbKey === scScatterplotDC) {
        this.createSelectOptions(undefined, nextProps.modifiedPreferences);
      } else if (field.dbKey === scScatterplotBase) {
        const oldScatterPlotBase = this.getKeyData(field.dbKey);
        const newScatterPlotBase = this.getKeyData(field.dbKey, false, nextProps.modifiedPreferences);
        const oldFamilySelectedId = this.getKeyData(scStudyFamily);
        const newFamilySelectedId = this.getKeyData(scStudyFamily, false, nextProps.modifiedPreferences);
        if (!_.isEqual(oldScatterPlotBase, newScatterPlotBase) || oldFamilySelectedId !== newFamilySelectedId) {
          let scatterplotBase = field.values[0];
          if (!_.isEmpty(newScatterPlotBase) && _.isArray(newScatterPlotBase)) {
            const index = _.findIndex(newScatterPlotBase, { studyFamilyId: newFamilySelectedId });
            if (index >= 0) {
              scatterplotBase = newScatterPlotBase[index].label;
            }
            this.setSelectedOption(scatterplotBase);
          }
        }
      }
    }
  }

  getKeyData = (key, defaultData, newData) => {
    const { modifiedPreferences, userPreference } = this.props;
    const keys = key.split('.');
    let dataKey;
    if (newData !== undefined) {
      dataKey = newData;
    } else {
      dataKey = defaultData ? userPreference : modifiedPreferences;
    }
    return !_.isEmpty(dataKey) ? dataKey[keys[0]][keys[1]] : undefined;
  }

  setSelectedOption = (value, newData) => {
    const { field } = this.props;
    let defaultVal;
    if (value !== undefined) {
      defaultVal = value;
    } else if (newData === undefined) {
        defaultVal = this.getKeyData(field.dbKey);
      } else {
        defaultVal = this.getKeyData(field.dbKey, false, newData);
      }
    if (!_.isEmpty(defaultVal)) {
      this.setState({
        selectedOption: typeof defaultVal === 'object' ? defaultVal :
        { label: defaultVal, value: defaultVal },
      });
    } else if (!_.isEmpty(field.defaultValue) && field.dbKey !== scScatterplotDC) {
      this.setState({
        selectedOption: { label: field.defaultValue, value: field.defaultValue },
      });
    } else {
      this.setState({
        selectedOption: undefined,
      });
    }
  }

  getProductNoFromStudyFamily = newData => {
    // This logic is specifally written for scatterplot for Brand and Sales Catalyst
    const { field, scStudies, bcStudies } = this.props;
    let studyFamily;
    let studies;
    if (field.dbKey === scScatterplotDC) {
      studyFamily = scStudyFamily;
      studies = scStudies;
    } else {
      studyFamily = bcStudyFamily;
      studies = bcStudies;
    }
    let familySelectedId;
    if (newData === undefined) {
      familySelectedId = this.getKeyData(studyFamily);
    } else {
      familySelectedId = this.getKeyData(studyFamily, false, newData);
    }
    familySelectedId = familySelectedId !== undefined ? familySelectedId : -1;
    const selectedStudies = _.find(studies, { id: familySelectedId });
    const productNo = _.isEmpty(selectedStudies) ? studies[0].sl[0].pn :
        selectedStudies.sl[0].pn;
    return productNo;
  }

  updatePreferences = (node, key) => {
    const { dbKey } = this.props.field;
    this.props.updatePreferences(
      key !== undefined ? key : dbKey,
      node
    );
  }

  createList = (listData, labelKey, valueKey, newData) => {
    const { dbKey, menuName } = this.props.field;
    const options = _.map(listData, o => (
      { label: labelKey ? o[labelKey] : o, value: valueKey ? o[valueKey] : o }
    ));
    if (dbKey === scSubEntitiesSlKey) {
      const entityInfo = this.getKeyData(scEntityPersonaKey, false, newData);
      if (_.isEmpty(entityInfo)) {
        _.remove(options, n => {
          return n.value === 0;
        });
      }
    }
    this.setState({
      options,
    }, () => {
      if ((dbKey === scScatterplotDC || dbKey === scScatterplotBase) && options.length > 0) {
        let selectedOption = '';
        const scatterPlotPref = this.getKeyData(dbKey, false, newData);
        const familySelectedId = this.getKeyData(
          menuName === 'SalesCatalyst' ? scStudyFamily : bcStudyFamily, false, newData);
        if (!_.isEmpty(scatterPlotPref) && _.isArray(scatterPlotPref)) {
          const index = _.findIndex(scatterPlotPref, { studyFamilyId: familySelectedId });
          if (index >= 0) {
            const selectedObj = scatterPlotPref[index];
            if (_.find(options, { label: selectedObj.label })) {
              selectedOption = selectedObj.label;
            }
          }
        } else {
          selectedOption = options[0].label;
        }
        this.setSelectedOption(selectedOption);
      }
    });
  }


  getKeyData = (key, defaultData, newData) => {
    const { modifiedPreferences, userPreference } = this.props;
    const keys = key.split('.');
    let dataKey;
    if (newData !== undefined) {
      dataKey = newData;
    } else {
      dataKey = defaultData ? userPreference : modifiedPreferences;
    }
    return !_.isEmpty(dataKey) ? dataKey[keys[0]][keys[1]] : undefined;
  }

  getStudyInfo = () => {
    const { field, scStudies, studies, bcStudies } = this.props;
    if (field.menuName === 'SalesCatalyst') {
      const getStudyInfo = this.getKeyData(scDefaultStudy);
      return getStudyInfo === -1 ? scStudies[0].sl[0].pn : getStudyInfo;
    }
    if (field.menuName === 'BrandCatalyst') {
      const getStudyInfo = this.getKeyData(bcDefaultStudy);
      return getStudyInfo === -1 ? bcStudies[0].sl[0].pn : getStudyInfo;
    }
    return studies[0].sl[0].pn;
  }

  createSelectOptions = (defaultData, newData) => {
    const { field, salesCatalystActions, loginResponse,
      activeAccountId } = this.props;
    if (defaultData !== undefined) {
      this.createList(defaultData);
      return;
    }
    if ((field.menuName === 'SalesCatalyst' || field.menuName === 'BrandCatalyst') && field.action !== undefined) {
      /**
        const storeKeyData = field.action.storeKey !== undefined ?
        salesCatalystData[field.action.storeKey] : undefined;
      if (!_.isEmpty(storeKeyData)) {
        this.createList(storeKeyData, field.action.labelKey, field.action.valueKey);
        this.setState({
          responseData: storeKeyData,
        });
        return;
      } * */
      const actionParams = {
        token: loginResponse.data.token,
        userId: loginResponse.data.uid,
        accountId: activeAccountId,
      };
      if (field.dbKey === scSubEntitiesSlKey) {
        actionParams.type = field.action.type;
      }
      if (field.dbKey === scScatterplotDC) {
        actionParams.dataReturn = true;
        actionParams.productNo = this.getProductNoFromStudyFamily(newData);
      }
      if (field.action.name === 'scActionGetMethod') {
        actionParams.productNo = this.getStudyInfo();
      }
      salesCatalystActions[field.action.name](actionParams).then(response => {
        this.createList(response, field.action.labelKey, field.action.valueKey, newData);
        this.setState({
          responseData: response,
        });
      });
    }
    
  }

  mountMethod = () => {
    const { field } = this.props;
    if (field.values !== undefined && !_.isEmpty(field.values)) {
      this.createSelectOptions(field.values);
    } else if (field.action !== undefined && !_.isEmpty(field.action)) {
      this.createSelectOptions();
    }
    if (field.dbKey !== scScatterplotDC && field.dbKey !== scScatterplotBase) {
      this.setSelectedOption();
    }
  }

  dropdownClickFn = data => {
    const { field, modifiedPreferences } = this.props;
    let selItem;
    if (field.dbKey === scScatterplotDC || field.dbKey === scScatterplotBase) {
      const studyFamilyKey = (field.dbKey === scScatterplotDC || field.dbKey === scScatterplotBase) ? 
        scStudyFamily : bcStudyFamily;
      const scatterPlotPref = this.getKeyData(field.dbKey, false, modifiedPreferences);
      const familySelectedId = this.getKeyData(studyFamilyKey, false, modifiedPreferences);
      if (_.isEmpty(scatterPlotPref) || !_.isArray(scatterPlotPref)) {
        selItem = [];
        selItem.push({ studyFamilyId: familySelectedId, label: data.label, value: data.label });
      } else {
        const index = _.findIndex(scatterPlotPref, { studyFamilyId: familySelectedId });
        if (index >= 0) {
          scatterPlotPref[index] = { studyFamilyId: familySelectedId, label: data.label, value: data.label };
        } else {
          scatterPlotPref.push({ studyFamilyId: familySelectedId, label: data.label, value: data.label });
        }
        selItem = scatterPlotPref;
      }
    } else {
      selItem = field.action !== undefined ? data : data.label;
    }
    this.updatePreferences(selItem);
    this.updateActionFn(data);
  }

  updateActionFn = data => {
    const { field, loginResponse, activeAccountId, scStudies } = this.props;
    if (field.updateAction && field.updateKey) {
      // Load SubEntity Template
      if (field.dbKey === scSubEntitiesSlKey) {
        const studyInfo = this.getKeyData(scDefaultStudy);
        const loadTemplateParams = {
          token: loginResponse.data.token,
          uid: loginResponse.data.uid,
          accountId: activeAccountId,
          type: field.updateAction.type,
          data: {
            templateId: data.value,
            productNo: studyInfo === -1 ? scStudies[0].sl[0].pn : studyInfo,
            weightType: 1,
          },
        };
        if (data.value === 0) {
          const entityInfo = this.getKeyData(scEntityPersonaKey)[0];
          loadTemplateParams.data = {
            ...loadTemplateParams.data,
            entityLabel: entityInfo.label,
            entityExpression: entityInfo.expression,
            vpctFilter: this.getKeyData(scReach),
            top: 15,
            minSampleSize: this.getKeyData(scSample),
          };
        }
        this.props.salesCatalystActions[field.updateAction.name](loadTemplateParams)
        .then(response => {
          if (response.subEntities === undefined) {
            this.setState({
              seErrorMsgFlag: true,
            });
            this.editListWarning.show();
            this.updatePreferences('');
          } else {
            const dataPoints = [];
            const invalidDataPoints = [];
            _.forEach(response.subEntities, o => {
              if (o.details[0] === null || (o.details[0] !== null && o.details[0].sample <= 0)) {
                invalidDataPoints.push(o);
              } else {
                dataPoints.push(o);
              }
            });
            this.setState({
              seInvalidDataPoints: invalidDataPoints,
              seErrorMsgFlag: false,
            }, () => {
              if (invalidDataPoints.length > 0) {
                this.editListWarning.show();
              }
            });
            let subEntityData;
            if (dataPoints.length > 0) {
              subEntityData = _.map(dataPoints, o => (
                {
                  label: o.label,
                  expression: o.expression,
                }
              ));
            } else {
              this.updatePreferences('');
            }
            this.updatePreferences(_.isEmpty(subEntityData) ? [] : subEntityData, field.updateKey);
            this.updatePreferences(data.label, field.updateKeySl);
          }
        });
      }
    }
  }

  render() {
    const { field } = this.props;
    const { options, selectedOption, seErrorMsgFlag, seInvalidDataPoints } = this.state;
    return (
      <div>
        <Modal
          title=""
          ref={node => {this.editListWarning = node;
            return this.editListWarning}}
          dialogStyles={editWarningStyle}
        >
          <div>
            {seErrorMsgFlag &&
              <div className="row">
                <div className="columns large-3 medium-3 small-3">
                  <img
                    className="study-popup-alertIcon"
                    src={alertIcon}
                    alt="Warning"
                  />
                </div>
                <div className="columns large-9 medium-9 small-9 study-popup-msg">
                  <p className="invalidDataPoints-header invalidDatapointMargin">{SC_PACKAGE_EDIT_LIST_WARNING}</p>
                </div>
              </div>
            }
            <div>
              {!seErrorMsgFlag &&
                <div>
                  <div className="invalidDataPoints-header">
                    <p>{INVALID_DATA_POINTS}</p>
                  </div>
                  <div className="study-popup-msg">
                    {seInvalidDataPoints.length > 0 &&
                      <div className="sc-edit-waring">
                        {_.map(seInvalidDataPoints, o => (
                          <div className="invalidDataPoints-label">{o.label}</div>
                        ))}
                      </div>
                    }
                  </div>
                </div>
              }
              <GenericButton
                btnStyle="button btn-cncl-edit-list"
                name="Close"
                onBtnClick={() => {
                  this.editListWarning.hide();
                }}
              />
            </div>
          </div>
        </Modal>
        <CommonDropdown
          listData={options}
          defaultSelected={selectedOption}
          itemClickFn={this.dropdownClickFn}
          placeHolder={field.placeholder}
          filterSearch={field.filterSearch}
        />
      </div>
    );
  }
}

PreferencesCommonDropdown.propTypes = {
  field: PropTypes.shape({
    values: PropTypes.arrayOf(PropTypes.string),
    defaultValue: PropTypes.arrayOf(PropTypes.shape({})),
    updateAction: PropTypes.shape({
      name: PropTypes.string,
      type: PropTypes.string,
    }),
    dbKey: PropTypes.string,
    placeholder: PropTypes.string,
    menuName: PropTypes.string,
    filterSearch: PropTypes.bool,
    updateKey: PropTypes.string,
    updateKeySl: PropTypes.string,
    action: PropTypes.shape({
      name: PropTypes.string,
      labelKey: PropTypes.string,
      valueKey: PropTypes.string,
      type: PropTypes.string,
    }),
  }),
  style: PropTypes.shape({
    width: PropTypes.string,
  }),
  updatePreferences: PropTypes.func,
  modifiedPreferences: PropTypes.shape({}),
  userPreference: PropTypes.shape({}),
  salesCatalystActions: PropTypes.shape({}),
  scStudies: PropTypes.arrayOf(PropTypes.shape({
    sl: PropTypes.arrayOf(PropTypes.shape({
      pn: PropTypes.number
    })),
  })),
  bcStudies: PropTypes.arrayOf(PropTypes.shape({
    sl: PropTypes.arrayOf(PropTypes.shape({
      pn: PropTypes.number
    })),
  })),
  studies: PropTypes.arrayOf(PropTypes.shape({
    sl: PropTypes.arrayOf(PropTypes.shape({
      pn: PropTypes.number
    })),
  })),
  loginResponse: PropTypes.shape({
    data: PropTypes.shape({
      uid: PropTypes.number,
      token: PropTypes.string,
    }),
  }),
  activeAccountId:PropTypes.number,  
};


function mapStateToProps(state) {
  return {
    loginResponse: state.login.loginResponse,
    activeAccountId: state.account.activeAccountId,
    userPreference: state.preferences.userPreferences,
    scStudies: state.study.salesCatalystStudies,
   // productNo: state.study.salesCatalystStudy.pn,
    bcStudies: state.study.insight360studies,
    studies: state.study.studies,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    salesCatalystActions: bindActionCreators(salesCatalystActions, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  )(PreferencesCommonDropdown);
